<template>
  <div class="home">
      <!-- <input class="my_search" type="text" placeholder="搜索内容"  v-model="searchQuery"><button class="my_search_button"  v-on:click="search_shop()">搜索</button> -->
      <!-- HTML 结构 -->
      <div class="search-bar">
        <input
          class="search-input"
          type="text"
          placeholder="请输入关键词"
          v-model="searchQuery"
          @keyup.enter="search_shop"
        >
        <button
          class="search-button"
          @click="search_shop"
        >
          搜索
        </button>
      </div>
    <!-- 左边列表start -->
    <div class="leftNav">
      <van-collapse
        v-model="activeName"
        accordion
      >
        <van-collapse-item
          v-for="(oneNav1,i) in oneNav"
          :name="i"
          :key="i"
        >
          <div
            slot="title"
            class="classification"
            v-on:click="texttiam(i)"
          >{{oneNav1.name}}</div>
          <li
            v-for="(under1,a) in oneNav1.under"
            :class="lmj_index == under1.id ? 'lmj_color':'classification_li'"
            v-on:click="texttiam1(a,under1.id)"
            :key="a"
            :id="'lmj' + under1.id"
          >{{under1.name}}</li>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div
      class="top_tu"
      id="top_tu"
      res="top_tu"
    ></div>
    <!-- 左边列表end -->

    <!-- right内容 start -->
    <div class="box">
      <!-- 广告位置 -->
      <div v-if="show == false">
      <a
        class="gg_url"
        v-for="(item, i) in imgList"

        :href="item.url"
        :key="i"
        :data-id="item.id"
      >
        <img
          class="rightCon1_lmj_delete"
          :src="item.face"
        />
      </a>
            </div>
      <!-- 广告end -->
      <van-loading
        v-show="addOff"
        color="#1989fa"
        id="loading_add"
        size="24px"
        vertical
      />

      <!-- 以下是商品列表页 -->
      <div
        class="rightCon"
        v-if="show"
        v-for="(oneNavlist1, index) in oneNavlist"
        :key="index"
      >
        <!-- <van-loading color="#1989fa" id="loading_add"  size="24px" vertical/> -->

        <div class="rightCon_left">
          <img :src="oneNavlist1.face" />
        </div>
        <div class="rightCon_right">
          <h4>{{oneNavlist1.name}}</h4>
          <div>
            <span>￥{{oneNavlist1.price}}元</span>
            <div>
              <div class="item_Right_bottom_right">
                <div
                :disabled='btnShow'
                  class="stepper__minus"
                  @click="
               amend(
                   oneNavlist1.count <= 0? 0: parseInt(oneNavlist1.count) - 1,
                  oneNavlist1,
                  index
               )"
                ></div>
                <!-- <van-button type="primary" icon="minus" round class="stepper__minus" @click="
               amend(
                   oneNavlist1.count <= 0? 0: parseInt(oneNavlist1.count) - 1,
                  oneNavlist1,
                  index
               )"/> -->
                <input
                  type="number"
                  class="van-stepper__input"
                  v-model="oneNavlist1.count"
               @blur="amend(oneNavlist1.count <= 0 ? 0: parseInt(oneNavlist1.count),
                  oneNavlist1,
                  index)"
                />
                <div
                :disabled='btnShow'
                  class="stepper__plus"
                  @click="
                amend(
                parseInt(oneNavlist1.count) + 1,
                oneNavlist1,
                index
               )"
                ></div>
                <!-- <van-button name='plus' type="primary" class="stepper__plus"/> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- right内容 end -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { TreeSelect } from "vant";
Vue.use(TreeSelect);
import API from "../../lmj_Api/api";

export default {
  data () {
    return {
      name: "home",
      oneNav: [], //分类列表
      oneNavlist: [], //商品列表
      activeName: "1",
      imgList: "", // 广告
      show: false,
      uid: this.$store.getters.get_user_id,
      lmj_index: "",
      addOff: false,
      btnShow:false,    //按钮禁用状态
      num:0,
      searchQuery: '' // 初始化绑定值
    };
  },

  mounted () {

    var that = this;
    that.$router.push({ path: "/lmjhome", query: { l: 1 } });
    that.init();
    that.img_gg();
    that.num_bottom(that, -999, undefined);
    that.$store.commit("bottom_nav", 1); //1.首页图标高量 2.购物车不处理 3.会员中心处理
  },

  methods: {
    //xhx 20250325 增加
    search_shop(){
      var that = this;
      var url = API.shopListSearch;
      if(this.searchQuery == ""){
        return;
      }
      // console.log('搜索内容：', this.searchQuery)
      this.show = true;
      this.activeName = "1";
      const descendantElements = document.querySelectorAll('.van-collapse-item .classification');
            descendantElements.forEach(el => el.style = '');
      const descendantElements1 = document.querySelectorAll('.van-collapse-item .top_tu');
            descendantElements1.forEach(el => el.style.display = 'none');
      that.lmj_index = "";

      this.axios
        .post(url, {
          search: this.searchQuery,
          user_id:that.uid,
        })
        .then(res => {
          this.oneNavlist = res.data.data;
          that.num_bottom(that);
        });
    },
    // 广告请求
    img_gg () {
      var that = this;
      var url = API.advertisement;
      this.axios.post(url).then(res => {
        if (res.data.code == 200) {
          that.imgList = res.data.data;
        }
      });
    },

    // 分类请求
    init () {
      var that = this;
      this.axios.post(API.type).then(response => {
        that.oneNav = response.data.data;
        setTimeout(() => {
          var xx = document.getElementsByClassName("van-cell");
          for (var i = 0; i < xx.length; i++) {
            xx[i].style.padding = "0rem";
          }
          var ii = document.getElementsByClassName(
            "van-collapse-item__content"
          );
        }, 0);
      });
    },
    //改变购物车里的数量
    amend (count, goods_parse, index) {
      if(!this.btnShow){

      this.addOff = true;
      this.btnShow=true;
      console.log(count, goods_parse, goods_parse.id);
      var url = API.ShopAdd,
        that = this,
        parse = {
          user_id: that.uid,
          shop_id: goods_parse.id,
          count: count,
          money: goods_parse.price,
          name: goods_parse.name
        };
      //  setTimeout(()=>{
         that.axios
        .post(url, parse)
        .then(res => {
          if (res.data.code == 200) {
            that.oneNavlist[index].count = count;
            var _id = goods_parse.id,
              _count = that.oneNavlist[index].count;
            that.num_bottom(that, _id, _count);
          } else {
            this.$toast.fail('请稍候再试');
            // 关闭loading 提示
           this.addOff = false
          //  关闭按钮禁用
           this.btnShow=false
          }
        });
      //  },500)
      }
    },

    num_bottom (that, id, count) {
      this.axios
        .post(API.ShoppingCart, {
          user_id: that.uid
        })
        .then(res => {
            this.addOff = false;
          this.btnShow=false;

          var num = 0;
          res.data.data.forEach((item) => {
            if (item.id == id) {
              num += count;
            } else {
              num += item.count;
            }
          });
          this.$store.commit("addNum", num);
        });
    },
    //点击事件分类里的项
    texttiam1 (e, id) {
      var that = this;
      that.lmj_index = id;
      var ii = document.getElementsByClassName("classification_li");
      // console.log("需要做这里")
      //清空搜索 开始
      // 通过类名获取输入框
      const input = document.querySelector('.search-input');
      // 清空值
      input.value = '';
      // 触发输入事件同步 Vue 的 v-model（关键！）
      input.dispatchEvent(new Event('input'));
      //清空搜索 结束

      // ii.appendChild(this.$refs.top_tu);
      for (var a = 0; a < ii.length; a++) {
        if (e == a) {
          ii[a].style.color = "#5CBAFF";
        } else {
          ii[a].style.color = "#7E7E7E";
        }
      }
      this.show = true;
      var that = this;
      var url = API.shopList;
      this.axios
        .post(url, {
          id: id,
          user_id: that.uid
        })
        .then(res => {
          this.oneNavlist = res.data.data;
          that.num_bottom(that);
        });
    },


    // 点击分类 走这个函数 给变样式 处理样式展示的
    texttiam (e) {
      var ii = document.getElementsByClassName("van-cell");
      for (var a = 0; a < ii.length; a++) {
        ii[a].children[0].children[0].style.background = "#f1f1f1";
        ii[a].children[0].children[0].style.color = "#6d6d6d";
      }
      // console.log("下面是什么")
      // console.log(this.oneNav)
      for (var m = 0; m < this.oneNav.length; m++) {
        this.oneNav[m].is_show = true;
      }
      var el_top = document.getElementById("top_tu");
      if (this.oneNav[e].is_show == true && this.oneNav[e].under.length != 0) {
        el_top.style.display = "block";
        this.oneNav[e].is_show = false;
      } else {
        el_top.style.display = "none";
        this.oneNav[e].is_show = true;
      }
      ii[e].children[0].children[0].style.background =
        "linear-gradient(90deg,rgba(123,212,255,1) 0%,rgba(92,186,255,1) 100%)";
      ii[e].children[0].children[0].style.color = "#fff";
      ii[e].children[0].children[0].appendChild(el_top);
      if (this.activeName == "" || this.activeName != e) {
      }
    },
  }
};
</script>
<style lang="less">
html,
body,
#app,
#app > div {
  width: 100%;
  height: 100%;
}
.home {
  height: 100%;
  // height:  calc(~"(100% - 1.2rem)");
  // padding-bottom: 1.2rem;
}

.leftNav::-webkit-scrollbar {
  display: none;
}
.leftNav {
  z-index: 999;
  overflow: hidden;
  width: 1.6rem;
  height: calc(100% - 1.2rem);
  display: inline-block;
  background: #f2f2f2;
  vertical-align: middle;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
}
/* for Chrome */
.inner-container::-webkit-scrollbar {
  display: none;
}
.element::-webkit-scrollbar {
  display: none;
}

.rightCon {
  width: 5.82rem;
  float: right;
  position: relative;
  #loading_add {
    position: absolute;
    top: 5rem;
    left: 2rem;
  }
}

// 修改侧边分类结构 statr
.van-collapse-item__content {
  padding: 0 !important;
}
.classification {
  position: relative;
  overflow: hidden;
  z-index: 99;
  width: 1.6rem;
  height: 0.99rem;
  //层叠掉背景色
  background: #f1f1f1;
  color: rgba(109, 109, 109, 1);
  font-size: 0.28rem;
  // border: 0rem;
  text-align: center;
  line-height: 1rem;
  font-family: PingFangSC-Semibold, PingFang SC;
}

.classification_li {
  list-style: none;
  width: 100%;
  height: 1rem;
  width: 1.68rem;
  background: #fff;
  color: #7e7e7e !important;
  line-height: 1rem;
  text-align: center;
  font-family: PingFangSC-Semibold, PingFang SC;
  z-index: 10;
  position: relative;
  float: left;
}
//清除浮动 li的父盒子有了高度 慢速张开 合毕 动画效果
.van-collapse-item__content::after {
  content: ' ';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.lmj_color {
  list-style: none;
  width: 100%;
  height: 1rem;
  width: 1.68rem;
  background: #fff;
  color: rgb(92, 186, 255) !important;
  line-height: 1rem;
  text-align: center;
  font-family: PingFangSC-Semibold, PingFang SC;
  z-index: 10;
  position: relative;
  float: left;
}
// 制造侧边栏的 上箭头
/* 错误示例：缺少单位或分号 */
.top_tu {
  position: absolute;
  bottom: -0.11rem;
  left: 0.7rem;
  background: white;
  z-index: 999;
  height: 0.22rem;
  width: 0.22rem;
  transform: rotate(45deg);  /* 注意此行 */
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  display: none;
}
// 修改侧边分类结构 end

//商品列表 内容statr
.box::-webkit-scrollbar {
  display: none;
}
.box {
  overflow: hidden;
  width: 5.9rem;
  height: calc(100% - 1.2rem);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  float: right;
  .gg_url {
    border-bottom: 0.02rem solid rgba(237, 237, 237, 1);
    width: 5.56rem;
    height: 3.46rem;
    display: block;
    margin-top: 0.16rem;
    margin-left: 0.16rem;
    img {
      width: 5.56rem;
      height: 3.46rem;
    }
  }

  .rightCon {
    border-bottom: 0.02rem solid rgba(237, 237, 237, 1);
    width: 5.9rem;
    height: 2.22rem;
  }
  .rightCon > div {
    height: 2.22rem;
  }

  .rightCon > .rightCon_left {
    height: 2.22rem;
    width: 1.96rem;
    display: inline-block;
  }

  .rightCon > .rightCon_left > img {
    margin: 0.26rem 0.14rem 0.26rem 0.26rem;
    width: 1.7rem;
    height: 1.7rem;
    display: inline-block;
    vertical-align: middle;
  }

  .rightCon > .rightCon_right {
    width: 3.8rem;
    height: 1.66rem;
    float: right;
    padding: 0.26rem 0;
    // position: absolute;
    // display: inline-block;
    vertical-align: middle;
  }
  .rightCon > a > img {
    width: 100%;
    height: 100%;
  }

  .rightCon_right > h4 {
    font-weight: normal;
    width: 2.6rem;
    height: 0.84rem;
    font-size: 0.3rem;
    margin: 0rem 0 0.45rem 0;
    font-family: PingFangSC-Medium, PingFang SC;
    color: rgba(74, 74, 74, 1);
  }

  .rightCon_right > div {
    margin-right: 0.25rem;
    height: 0.52rem;
    line-height: 0.42rem;
  }

  .rightCon_right > div > span {
    font-size: 0.3rem;
    font-family: PingFangSC-Medium, PingFang SC;
    color: rgba(255, 93, 51, 1);
    display: inline-block;
    vertical-align: top;
    width: 1.76rem;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }

  .rightCon_right > div > div {
    float: right;
    font-family: PingFangSC-Medium, PingFang SC;
  }

  .rightCon_right > div > div > img {
    width: 0.42rem;
    height: 0.42rem;
    display: inline-block;
    vertical-align: middle;
  }
  .item_Right_bottom_right {
    width: 1.65rem;
    height: 0.52rem;
    margin-top: -0.05rem;
    // margin-left: 0.2rem;
    display: flex;
  }

  .rightCon1_img {
    width: 5.56rem;
    margin: 0.14rem 0.16rem 0rem 0.1rem;
    height: 3.46rem;
    display: block;
  }
}
#loading_add {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
//全局步进器样式
<style  lang="less">
.stepper__minus {
  display: inline-block;
  z-index: 99;
  border: none;
  width: 0.5rem;
  height: 0.5rem;
  color: rgba(0, 0, 0, 0);
  background: url('../../images/hb_eee.png');
  background-position: 0px 0px;
  background-size: 0.5rem 0.5rem;
}
.van-stepper__input {
  width: 0.60rem !important;
  width: 0.64rem !important;
  height: 0.52rem !important;
  background: none !important;
  padding: 0rem !important;
  border: none !important;
  margin: 0rem !important;
}
.stepper__plus {
  display: inline-block;
  height: 0.6rem;
  border: none;
  width: 0.6rem;
  margin-top: -0.02rem;
  height: 0.55rem;
  width: 0.55rem;
  z-index: 99;
  color: rgba(0, 0, 0, 0);
  background: url('../../images/hb7.png') no-repeat !important;
  background-position: 0px -0.02rem !important;
  background-size: 0.55rem 0.55rem !important;
  background-size: 0.52rem 0.52rem !important;
}



/* 移动端优化样式 */
.search-bar {
  /* position: fixed; 固定在顶部 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 8px; /* 输入框和按钮间距 */
  padding: 12px 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1); /* 底部阴影 */
}

.search-input {
  flex: 1; /* 占据剩余空间 */
  height: 44px; /* 最小触摸高度 */
  padding: 0 16px;
  border: 1px solid #eeeeee;
  border-radius: 24px; /* 胶囊形状 */
  font-size: 16px;
  color: #333;
  background: #f8f8f8;
  outline: none;
  transition: border-color 0.3s;
  -webkit-appearance: none; /* 去除 iOS 默认样式 */
}

/* 输入框聚焦效果 */
.search-input:focus {
  border-color: #007aff; /* iOS 风格蓝色 */
  background: #ffffff;
}

.search-button {
  flex-shrink: 0; /* 禁止按钮缩小 */
  width: 80px;
  height: 44px;
  border: none;
  border-radius: 24px;
  background: #007aff;
  color: white;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.3s;
}

/* 按钮点击反馈 */
.search-button:active {
  background: #0051a8;
}

/* 占位符颜色优化 */
::placeholder {
  color: #999;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/lmj/home.vue